var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wisdom-store" }, [
    _c(
      "div",
      { staticClass: "store-content padding-main mobile-padding" },
      [
        _c(
          "el-row",
          [
            _c(
              "el-col",
              { staticClass: "store-desc", attrs: { xs: 24, sm: 24, md: 8 } },
              [
                _c("div", { staticClass: "store-title" }, [
                  _vm._v(_vm._s(_vm.$t("wisdomStore.wisdomStore"))),
                ]),
                _c("div", { staticClass: "store-tip" }, [
                  _vm._v(_vm._s(_vm.$t("wisdomStore.wisdomStoreTip1"))),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("wisdomStore.wisdomStoreTip2"))),
                  ]),
                ]),
              ]
            ),
            _c(
              "el-col",
              {
                staticStyle: { "text-align": "right" },
                attrs: { xs: 24, sm: 24, md: 16 },
              },
              [
                _c(
                  "div",
                  { staticClass: "image-flex" },
                  [
                    _c("el-image", {
                      staticClass: "store-image",
                      attrs: { src: "/img/wisdom_store.png", fit: "cover" },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "store-list padding-main mobile-padding" }, [
      _c("div", { staticClass: "list-name" }, [
        _vm._v(_vm._s(_vm.$t("wisdomStore.features"))),
      ]),
      _c(
        "div",
        { staticClass: "list" },
        [
          _vm._l(_vm.featuresList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "list-item" },
              [
                _c("el-image", {
                  attrs: {
                    src: _vm.vaildatePc() ? item.icon : item.mobile_icon,
                    fit: "cover",
                  },
                }),
                _c("div", { staticClass: "item-name" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c("div", { staticClass: "item-content" }, [
                  _vm._v(_vm._s(item.describe)),
                ]),
              ],
              1
            )
          }),
          _c("div", { staticClass: "list-item list-last hidden-sm-and-down" }, [
            _vm._v("\n        features\n      "),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }